import React from 'react';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Dot } from '../../../../../../../CommonComponents/OPL/Dot/Dot';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';
import { StackedBar } from '../../../../../../../CommonComponents/OPL/charts/StackedBar/StackedBar';
import { formatPercentage } from '../../../../../../../CommonUtils/formatNumber';
import { ChartItem } from '../../../../../../api/useBalanceSheetQuery';

interface Props {
  data: ChartItem[];
  total: number;
}

export const Chart = ({ data, total }: Props) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      css={({ theme }) => ({ gap: theme.space['8'] })}
      flex="1"
    >
      <StackedBar data={data} />

      <Box display="flex" css={({ theme }) => ({ gap: theme.space['8'] })}>
        {data.map(({ label, value, color }) => (
          <Box
            display="flex"
            alignItems="center"
            key={label}
            css={({ theme }) => ({ gap: theme.space['2'] })}
          >
            <Dot bg={color} />
            <Text fontSize="small">{label}</Text>
            <Text fontSize="small" fontWeight={700}>
              {formatPercentage(Math.abs(value) / Math.abs(total))}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
